import styled from '@emotion/styled';
import { Form } from 'antd';

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: ${props => props.theme.spacing.sm};
  width: 100%;
  font-size: 14px;
`;
